export var WTSResponseType;
(function (WTSResponseType) {
    WTSResponseType["ResultV2"] = "WtsResultV2";
    WTSResponseType["Result"] = "WtsResult";
    WTSResponseType["Response"] = "WtsResponse";
})(WTSResponseType || (WTSResponseType = {}));
export const getResponseType = (response) => {
    if ('Error' in response
        && !('Success' in response)
        && !('ResultCode' in response)) {
        return WTSResponseType.Result;
    }
    else if ('Errors' in response || 'Warnings' in response) {
        return WTSResponseType.ResultV2;
    }
    return WTSResponseType.Response;
};
